import React from 'react';
import { faTruckRampCouch } from '@fortawesome/pro-regular-svg-icons/faTruckRampCouch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TruckRampCouchRegularIcon(props) {
  return <FontAwesomeIcon icon={faTruckRampCouch} {...props} />;
}
